import { computed, ref } from 'vue'
import { useChatStore as useChatStoreCore } from '@/modules/chat-matrix-fast/stores/chatStore'
import type { IEmployeeTreeDepartment } from '@/modules/apiStore/types/employees/IEmployeeTree'
import { countEmployeesInTree, filterEmployeesTreeByMatrixUserId } from '@/modules/chat-matrix-fast/utils/employeeTree'

/** Дерево сотрудников с matrix_user_id для выбора участников чата */
export function useChatEmployees() {
  const chatStore = useChatStoreCore()
  const employeesTree = ref<IEmployeeTreeDepartment[]>([])
  const isLoaded = ref(false)
  let loadPromise: Promise<void> | null = null

  async function load(force = false): Promise<void> {
    if (!force && isLoaded.value) {
      return
    }

    if (loadPromise) {
      return loadPromise
    }

    loadPromise = (async () => {
      employeesTree.value = filterEmployeesTreeByMatrixUserId(await chatStore.fetchEmployeesTree())
      isLoaded.value = true
    })().finally(() => {
      loadPromise = null
    })

    return loadPromise
  }

  const totalCount = computed(() => countEmployeesInTree(employeesTree.value))

  return { employeesTree, totalCount, load, isLoaded }
}
